"use client";

import { Facebook, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <nav className="flex flex-col gap-2">
        <div className="h-5 w-20 bg-muted-light-background/40 animate-pulse rounded" />
        <div className="h-5 w-24 bg-muted-light-background/40 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted-light-background/40 animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted-light-background/40 animate-pulse rounded" />
        <div className="h-5 w-24 bg-muted-light-background/40 animate-pulse rounded" />
      </nav>;
  }
  return <nav className="flex flex-col gap-2">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-foreground-dark hover:text-accent-dark transition-colors duration-[var(--duration-medium)] hover:underline underline-offset-4">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    once: true,
    threshold: 0.1
  });
  return <footer ref={ref} className={`w-full bg-dark-background py-12 px-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
        {}
        <div className="flex items-center justify-center md:justify-start">
          <p className="text-foreground-dark text-sm">
            © {new Date().getFullYear()} Texas Margaritas Mexican Restaurant. All
            rights reserved.
          </p>
        </div>

        {}
        <div className="flex items-center justify-center">
          <MenuProvider menu_id="18" className="footer-navigation">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>

        {}
        <div className="flex items-center justify-center md:justify-end gap-4">
          <Link to="https://www.facebook.com/profile.php?id=61587320961527" newTab aria-label="Visit our Facebook page" className="text-foreground-dark hover:text-accent-dark transition-all duration-[var(--duration-medium)] hover:scale-110 animate-pulse hover:animate-none">
            <Facebook className="size-6" />
          </Link>
          <Link to="https://www.instagram.com/texasmargaritascarmel2026/" newTab aria-label="Visit our Instagram page" className="text-foreground-dark hover:text-accent-dark transition-all duration-[var(--duration-medium)] hover:scale-110 animate-pulse hover:animate-none">
            <Instagram className="size-6" />
          </Link>
          <Link to="https://www.tiktok.com/@texasmargaritascarmel" newTab aria-label="Visit our TikTok page" className="text-foreground-dark hover:text-accent-dark transition-all duration-[var(--duration-medium)] hover:scale-110 animate-pulse hover:animate-none">
            <svg className="size-6" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
            </svg>
          </Link>
        </div>
      </div>
    </footer>;
}